import { ISanityVendorConfigs } from '@rbi-ctg/menu';

export enum PluTypes {
  CONSTANT = 'constantPlu',
  IGNORE = 'ignore',
  MULTI_CONSTANT = 'multiConstantPlus',
  PARENT_CHILD = 'parentChildPlu',
  QUANTITY = 'quantityBasedPlu',
  SIZE_BASED = 'sizeBasedPlu',
}

export enum PosVendors {
  BRINK = 'brink',
  BRINK_DELIVERY = 'brinkDelivery',
  CARROLLS = 'carrols',
  CARROLS_DELIVERY = 'carrolsDelivery',
  NCR = 'ncr',
  NCR_DELIVERY = 'ncrDelivery',
  QDI = 'qdi',
  QDI_DELIVERY = 'qdiDelivery',
  RPOS = 'rpos',
  RPOS_DELIVERY = 'rposDelivery',
  SICOM = 'sicom',
  SICOM_DELIVERY = 'sicomDelivery',
  SIMPHONY = 'simphony',
  SIMPHONY_DELIVERY = 'simphonyDelivery',
  XENIAL = 'xenial',
  XENIAL_DELIVERY = 'xenialDelivery',
}

export enum PluQualifier {
  ADD = 'ADD',
  HALF = '1/2',
  NO = 'NO',
}

export interface IWithVendorConfig {
  _type?: string;
  type?: string;
  name?: { locale: string } | string;
  vendorConfigs?: ISanityVendorConfigs | null;
}

export interface IComboWithVendorConfig extends IWithVendorConfig {
  mainItem?: IWithVendorConfig;
}
